<template>
    <div class="kiaf-login-view-center-mode">
        <div v-loading="isLogined"></div>
        <div v-show="!isLogined" class="main-login">
            <img class="login-bg" :src="customize.images.bg" alt="">
            <img class="img-text" :src="customize.images.subject" alt="">
            <div class="login-right">
                <div class="login-logo">
                    <img class="login-logoimg" :src="customize.images.logo">
                </div>
                <h3 class="slogan">{{customize.labels.subject}}</h3>
                <kc-form :model="models" ref="loginForm">
                    <div class="user-name">
                        <kc-form-item prop="username">
                            <kc-input placeholder="用户名" v-model="models.username" auto-complete="off"  name="usernameInput">
                                <i slot="prefix" class="kedaIconfont KD-yonghuming"></i>
                            </kc-input>
                        </kc-form-item>
                    </div>
                    <div class="user-password">
                        <kc-form-item prop="password">
                            <kc-input placeholder="密码" type="password" v-model="models.password" auto-complete="off"  name="pwdInput">
                                <i slot="prefix" class="kedaIconfont KD-mima"></i>
                            </kc-input>
                        </kc-form-item>
                    </div>
                    <div class="box">
                        <kc-checkbox v-model="rememberUser" class="remember-user">记住用户名</kc-checkbox>
                    </div>
                    <div class="valid-button">
                        <kc-button type="primary" @click="userLogin()" id="pwdLoginBtn" :loading="loading">
                            登录{{loading?'中':''}}
                        </kc-button>
                        <kc-button class="ukey" @click="casLogin()" id="casLoginBtn">{{customize.labels.casLogin}}
                        </kc-button>
                    </div>
                </kc-form>
            </div>
            <footer class="copyright">{{customize.labels.copyright}}</footer>
        </div>
        <kc-modal
                v-if="forceUpdatePwd"
                title="请修改相关密码"
                width="20rem"
                :visible.sync="forceUpdatePwd"
                v-model:visible="forceUpdatePwd"
                :close-on-click-modal="false"
                class="change-password"
                :fullscreen-bg="true"
                @close="handlePwdUpdated"
        >
            <kiaf-person-setting ref="updatePwd" hideHomePage="true" :force-update-pwd="true" @pwdUpdated="handlePwdUpdated"></kiaf-person-setting>
            <kc-button
                    round
                    type="primary"
                    plain
                    @click="savePassword()"
            >保存
            </kc-button>
        </kc-modal>

    </div>

</template>

<script>
  import mixins from '../mixins/login';
  import useDownloadBrowser from '../mixins/useDownloadBrowser';

  export default {
    mixins: [mixins],
    data() {
      return {
        // images: {
        //     bg: require('../../../../theme/src/images/login-bg-centermode.png'),
        //     subject: require('../../../../theme/src/images/login-text-centermode.png'),
        //     logo: require('../../../../theme/src/images/police-emblem.png')
        // }
      };
    },
    setup() {
      return {
        ...useDownloadBrowser()
      };
    },
    created() {
      if (!this.customize.images.bg) {
        this.$set(this.customize.images, 'bg', './static/kiaf-baseui/images/login-bg-centermode.png');
      }
      if (!this.customize.images.subject) {
        this.$set(this.customize.images, 'subject', './static/kiaf-baseui/images/login-text-centermode.png');
      }
      if (!this.customize.images.logo) {
        this.$set(this.customize.images, 'logo', './static/kiaf-baseui/images/police-emblem.png');
      }
      console.log('kiaf>>>', this.customize);
    }
  };
</script>
<style lang="scss">
    @import "index.scss";
</style>
